import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { CornerRadiiState } from './cornerRadii.types';

import { CornerRadiusModel } from '~/core/models';

const initialState: CornerRadiiState = {
  selectedCornerRadius: undefined,
};

const cornerRadiiSlice = createSlice({
  name: 'cornerRadius',
  initialState,
  reducers: {
    updateSelectedCornerRadius: (
      state,
      action: PayloadAction<CornerRadiusModel>
    ) => {
      state.selectedCornerRadius = action.payload;
    },
    resetSelectedCornerRadius: (state) => {
      state.selectedCornerRadius = initialState.selectedCornerRadius;
    },
  },
});

export const { updateSelectedCornerRadius, resetSelectedCornerRadius } =
  cornerRadiiSlice.actions;

export default cornerRadiiSlice.reducer;
